import {CodeStyleSheet, defaultCodeStyle, FancyCodeStyleSheet} from "./defaults";
import {mergeStyles} from "../types";

export function createCodeStyle(style?: CodeStyleSheet): FancyCodeStyleSheet {
    return style ? mergeStyles(style, defaultCodeStyle) : defaultCodeStyle
}